<template>
  <ProtoNavigationBar
    v-bind="$attrs"
    theme="accadisHSTheme"
    image="/img/icon-socialmedia.png"
  >
    <template #title>
      <span class="font-bold">#weareaccadis</span>
    </template>
  </ProtoNavigationBar>
</template>
